/*
 * analytics.js — Custom-Event-Bridge (nativ, Web Pixels).
 *
 * Lädt KEINE Analytics-Tags. GA4, Microsoft Clarity und Meta Pixel werden
 * NATIV über Shopify eingebunden (Google-&-YouTube-Channel mit Consent Mode v2,
 * Meta-Channel, Clarity-App bzw. ein Custom Pixel unter Einstellungen →
 * Kundenereignisse). Siehe docs/14-analytics-native.md.
 *
 * Warum hier nichts mehr lädt:
 *  - Standard-E-Commerce-/Seiten-Events (page_viewed, product_viewed,
 *    product_added_to_cart, checkout_completed, purchase …) emittiert Shopify
 *    selbst über die Web-Pixels-Ebene — inkl. Checkout/Danke-Seite, die das Theme
 *    gar nicht erreicht. Pixel abonnieren diese direkt. Kein Theme-Forwarding nötig.
 *  - Consent (inkl. Consent Mode v2 / anonymes Modeling bei Ablehnung) wird von
 *    Shopify + den nativen Integrationen aus der Customer-Privacy-API durchgesetzt
 *    (Quelle = unser Consent-Banner, consent.js).
 *
 * Diese Datei publiziert NUR die theme-eigenen Interaktions-Events (die Shopify
 * nicht kennt) an die Web-Pixels-Ebene via Shopify.analytics.publish — ein Custom
 * Pixel kann sie abonnieren und z. B. als GA4-Event weiterreichen. Ohne aktiven
 * Pixel ist das ein No-Op. Keine PII, alles in try/catch.
 */
(function () {
  'use strict';

  function publish(name, detail) {
    try {
      var a = window.Shopify && window.Shopify.analytics;
      if (a && typeof a.publish === 'function') {
        a.publish('homedia:' + name, detail || {});
      }
    } catch (e) {}
  }

  // Kompatibilitäts-Finder (compat-finder.js dispatcht diese DOM-Events).
  document.addEventListener('compat:check', function (e) {
    var d = (e && e.detail) || {};
    publish('compatibility_check', {
      system: d.system,
      system_key: d.system_key,
      hub: d.hub,
      hub_name: d.hub_name,
      verdict: d.verdict
    });
  });

  document.addEventListener('compat:select_ecosystem', function (e) {
    var d = (e && e.detail) || {};
    publish('select_ecosystem', { system: d.system, system_key: d.system_key });
  });

  // Raum-Lösungsseiten (room.js dispatcht dieses DOM-Event bei Auswahl im Ökosystem-Filter).
  document.addEventListener('room:select_ecosystem', function (e) {
    var d = (e && e.detail) || {};
    publish('select_ecosystem', { system: d.system, system_key: d.system_key });
  });

  // Heizkosten-Rechner (heizkosten.js dispatcht dieses DOM-Event, debounced, ohne PII).
  document.addEventListener('heizkosten:calculate', function (e) {
    var d = (e && e.detail) || {};
    publish('heizkosten_calculate', {
      scenario: d.scenario,
      heating: d.heating,
      basis: d.basis,
      surface: d.surface,
      billing: d.billing,
      savings: d.savings,
      co2: d.co2
    });
  });

  // Hilfe-Seite (help.js dispatcht dieses DOM-Event beim „War das hilfreich?"-Voting, ohne PII).
  document.addEventListener('help:feedback', function (e) {
    var d = (e && e.detail) || {};
    publish('help_feedback', { id: d.id, value: d.value, page: d.page });
  });
})();
